(function($) {
    $('.single-product-slider').on('init', function(event, slick) {
        $(".single-product-slider, .summary").wrapAll("<div class='product-top-wrapper'><div class='row'></div></div>");
    });

})(jQuery);